import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { SubmitAuthService } from '../services/submit-auth.service';

export const SubmitAuthGuard: CanActivateFn = () => {
  const submitAuthService = inject(SubmitAuthService);
  if (submitAuthService.canSubmit()) {
    return true;
  }
  return false;
};
